export const ProfileEditIcon = ({ primaryColor = '#ffd800', primaryFontColor = '#3b4046' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 22 22"
    >
      <g
        id="Group_43720"
        data-name="Group 43720"
        transform="translate(-1168 -162.704)"
      >
        <circle
          id="Ellipse_1247"
          data-name="Ellipse 1247"
          cx="7"
          cy="7"
          r="7"
          transform="translate(1168 162.704)"
          fill={primaryColor}
        />
        <g
          id="Layer_92"
          data-name="Layer 92"
          transform="translate(1172.13 166.831)"
        >
          <path
            id="Path_24425"
            data-name="Path 24425"
            d="M16.69,2.264a.862.862,0,0,0-1.228,0l-.552.561,1.219,1.219.552-.552a.862.862,0,0,0,.009-1.228Z"
            transform="translate(-11.202 -2.008)"
            fill={primaryFontColor}
          />
          <path
            id="Path_24426"
            data-name="Path 24426"
            d="M5.312,6.27,2.9,8.682a.331.331,0,0,0-.055.075l-.8,1.613a.286.286,0,0,0,.377.394l1.613-.8a.331.331,0,0,0,.075-.055L6.523,7.5Z"
            transform="translate(-2.013 -5.045)"
            fill={primaryFontColor}
          />
        </g>
      </g>
    </svg>
  );
};
